import UserProfile from "./UserProfile";
export default class Project {
  constructor(project) {
    this.initializeData();
    this.extraDataFetched = false;
    this.setData(project);
  }

  initializeData() {
    const defaultValue = {
      // GENERIC RELATED DATA
      uuid: null,
      project_id: null,
      alerts: [],
      created_by_old_rapso: false,
      is_archived: false,
      questionnaires_completed: {},
      questionnaire_fetched_at: null,
      questionnaire_redirection_allowed: true,
      is_favorite: false,
      is_project_in_bim: false,
      origin_id: null,
      project_city: "",
      project_name: "",
      phase: "",
      sps_category: "",
      sps_phase: "",
      created_at: null,
      updated_at: null,
      atlas_methodo: "",
      chronorapso: null,
      sections_updated_at: null,
      // FIXME: I left is_duplicated_from that because I didn't know if it was used and side effect that can be caused if I remove its
      is_duplicated_from: null,
      is_duplicated_froms: [],
      has_access: false,
      entity: null,
      reports_survey: {},

      //batches
      batches: [],

      // CASE RELATED DATA
      cloud: null,
      contracting_agency: null,
      contracting_agency_code: null,
      subcontracting_agency: null,
      case_number: null,
      case_label: null,
      case_situation: null,
      case_status: null,
      forced_status: null,
      client_code: null,
      client_label: null,
      client_postcode: null,
      client_address: null,
      client_city: null,
      client_telephone: null,
      client_mobile: null,
      client_email: null,
      contact_company: null,
      contact_legal_form: null,
      contact_first_name: null,
      contact_last_name: null,
      contact_role: null,
      contact_postcode: null,
      contact_address: null,
      contact_telephone: null,
      contact_mobile: null,
      contact_email: null,
      contact_city: null,
      client_siren: null,
      client_nic: null,
      client_updated_in_rapsotec: null,
      decision_center_code: null,
      decision_center_label: null,
      financial_stakeholder_first_name: null,
      financial_stakeholder_last_name: null,
      initial_amount: null,
      final_amount: null,
      ope_start_date: null,
      estimated_duration: null,
      sign_date: null,
      total_before_tax: null,
      facturation_calcul_mode: null,
      is_cea: null,
      cea_ref: "",
      is_defense_secret: null,
      invoice_date_last_deadline: null,
      agency_country: "",
      case_postcode: "",
      is_national_contract: null,

      // CANVAS CONFIGURATION && MISSION TAB DATA
      missions: [],
      destinations: [],
      main_destination: "",
      types: [],
      other_missions: [],
      work_description: "",
      is_project_rpp: null,
      mission_information: "",
      mission_limits: "",
      additional_comments: "",

      // AFFAIRE TAB RELATED DATA
      rict_publication_date: null,
      project_address: "",
      project_postcode: "",
      building_permit_request_date: null,
      building_permit_number_of_bp: null,
      building_permit_acquisition_date: null,
      building_permit_possible_amendments: null,
      permit_type: "",
      dce_date: null,
      deadline_type: null,
      date_work_deadline: null,
      show_fields_characteristics: null,
      building_permit_competent_authority_name: null,
      safety_register_constitution_status: null,
      safety_register_revision_date: null,
      cover_photo: null,

      // RVRAT RELATED DATA
      old_rvrat_data: "",
      pab_main_activity: "",
      old_pab_main_activity: "",
      pab_category: null,
      number_of_buildings: null,
      number_of_levels: null,
      constructive_specificities_third_party: null,
      constructive_specificities_atrium: null,
      constructive_specificities_not_modified_by_work: null,
      installation_techniques_smoke: null,
      installation_techniques_heating_mode: null,
      installation_techniques_gas_or_hydrocarbons: null,
      installation_techniques_security_installation: null,
      installation_techniques_HT_station: null,
      installation_techniques_emergency_lighting: null,
      installation_techniques_restaurant_equipment: null,
      installation_techniques_lift: null,
      installation_techniques_extinguishers: null,
      installation_techniques_SSI: null,
      installation_techniques_alarm: null,
      staffings: [],
      clearances: [],
      room_clearances: [],
      justifications: [],
      measurements: [],
      safety_reviews: [],
      staffing_comment: "",
      clearance_comment: "",
      room_clearance_comment: "",
      safety_commission_prescription: "",
      disabled_evacuation_process: "",
      safety_commission_date: null,
      technical_checks_end_date: null,

      // WEBMAIL RELATED DATA
      webmail_login: "",
      webmail_email: "",
      webmail_primary_id: "",
      webmail_password: "",

      // TIMELINE RELATED DATA
      last_report: null, // Object<{report_date, name}>
      fees_data: null, // Object<{project_fees<Sales>, case_fees<Sales>}>  ----> Sales<{sale_amount<SaleData>, invoiced_fee<SaleData>}> ----> SaleData<{sales_A,sales_HCDA,sales_HBAG,sales_HBAA,sales_ct,sales_other,sales_total}>
      contractual_scope: null, // Object<{atlas_to_canvas_code<Object>, mission_not_in_atlas<Array>}>
      project_work_start_date: null, // Date
      project_real_duration: null, //Duration

      // ITM RELATED DATA
      non_verified_parts_not_realised: "",
      non_verified_parts_out_of_mission: "",
      additional_prescriptions: null,
      prescription_disposition: "",
      exemptions_granted: null,
      exemption_details: "",
      low_voltage: null, // LowVoltage
      fire_detection: null, // FireDetection
      risky_locals: null, // RiskyLocals
      lightning: null,
    };

    for (let [key, value] of Object.entries(defaultValue)) {
      this[key] = value;
    }
  }

  setData(project) {
    if (project.project_manager) {
      this.project_manager = new UserProfile(project.project_manager);
      delete project["project_manager"];
    }

    // ----------------- SET PROJECT DATA HERE ----------
    for (let [key, value] of Object.entries(project)) {
      if (key in this) {
        this[key] = value;
      }
    }

    // computed data
    this.worksProgress = this.getWorksProgress();
  }
  getWorksProgress() {
    const startDate = this.project_work_start_date || this.ope_start_date;
    if (!startDate || !this.estimated_duration) {
      return 0;
    }

    const formattedStartDate = new Date(startDate);
    const dateNow = new Date();

    const completedMonth =
      (dateNow - formattedStartDate) / (1000 * 60 * 60 * 24 * 30.5);

    if (completedMonth < 0) return 0;
    if (completedMonth > this.estimated_duration) return 100;

    return Math.round((completedMonth / this.estimated_duration) * 100);
  }

  getSaleAmountDetails(caseOrProjectKey, totalOrInvoiced) {
    /*
    :params caseOrProjectKey: can be project_fees or case_fees
    :params totalOrInvoiced: can be undefined or invoiced_fee or sale_amount
    */
    // A.C 04/08/26 fees_data peut être null (atlas injoignable ou projet inconnu d'atlas) : il
    // faut garder chaque niveau, un test de vérité sur fees_data seul laisse passer un objet
    // partiel et le déréférencement casse plus bas (cf. RTEC-3326).
    const fees = this.fees_data?.[caseOrProjectKey];
    if (!fees) {
      return "";
    }
    if (!totalOrInvoiced) {
      if (!fees.invoiced_fee || !fees.sale_amount) {
        return "";
      }
      return `
        AXXX: ${fees.invoiced_fee.sales_A} / ${fees.sale_amount.sales_A}
        HCDA: ${fees.invoiced_fee.sales_HCDA} / ${fees.sale_amount.sales_HCDA}
        HBAG: ${fees.invoiced_fee.sales_HBAG} / ${fees.sale_amount.sales_HBAG}
        HBAA: ${fees.invoiced_fee.sales_HBAA} / ${fees.sale_amount.sales_HBAA}
        ---> total ct: ${fees.invoiced_fee.sales_ct} / ${fees.sale_amount.sales_ct}
        other: ${fees.invoiced_fee.sales_other} / ${fees.sale_amount.sales_other}
        ---> total all: ${fees.invoiced_fee.sales_total} /  ${fees.sale_amount.sales_total}

        Legend: Atlas code: Montant facturé / Montant prévue`;
    }
    if (!fees[totalOrInvoiced]) {
      return "";
    }
    return `AXXX: ${fees[totalOrInvoiced].sales_A}
      HCDA: ${fees[totalOrInvoiced].sales_HCDA}
      HBAG: ${fees[totalOrInvoiced].sales_HBAG}
      HBAA: ${fees[totalOrInvoiced].sales_HBAA}
      ---> total ct: ${fees[totalOrInvoiced].sales_ct}
      other: ${fees[totalOrInvoiced].sales_other}
      ---> total all: ${fees[totalOrInvoiced].sales_total}

      Legend: Atlas code: Montant`;
  }
}
